// src/contexts/financeiro/ContaBancoContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api.js';
import Alert from '../../components/alert/Alert.js';

const ContaBancoContext = createContext();

export const useContaBanco = () => useContext(ContaBancoContext);

export const ContaBancoProvider = ({ children }) => {
    const [contasBanco, setContasBanco] = useState([]);

    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');

    // Modal para buscar contas bancárias

    const showMessage = (message, type = 'success') => {
        setAlertMessage(message);
        setAlertType(type);
        setShowAlert(true);
        setTimeout(() => setShowAlert(false), 3000);
    };

    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                const result = await fetchData('/ContaBanco');
                setContasBanco(result);
            } catch (error) {
                console.error("Erro ao buscar contas bancárias:", error);
            }
        };
        fetchDataFromAPI();
    }, []);

    const addContaBanco = async (contaBanco) => {
        try {
            const result = await postData('/ContaBanco', contaBanco);
            setContasBanco([...contasBanco, result]);
            showMessage('Conta bancária adicionada com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar conta bancária:", error);
            showMessage('Erro ao adicionar conta bancária', 'danger');
        }
    };

    const updateContaBanco = async (contaBanco) => {
        try {
            await putData('/ContaBanco', contaBanco);
            setContasBanco(contasBanco.map(c => c.id === contaBanco.id ? contaBanco : c));
            showMessage('Conta bancária atualizada com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar conta bancária:", error);
            showMessage('Erro ao atualizar conta bancária', 'danger');
        }
    };

    const deleteContaBanco = async (id) => {
        try {
            await deleteData('/ContaBanco', { contaBancoId: id }); // Exclusão da conta bancária no servidor
            setContasBanco(contasBanco.filter(c => c.id !== id));
            showMessage('Conta bancária excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir conta bancária:", error);
            showMessage('Erro ao excluir conta bancária', 'danger');
        }
    };

    return (
        <ContaBancoContext.Provider value={{
            contasBanco,
            addContaBanco, updateContaBanco, deleteContaBanco,            
        }}>
            <Alert
                show={showAlert}
                message={alertMessage}
                type={alertType}
                onClose={() => setShowAlert(false)}
            />

            
            {children}
        </ContaBancoContext.Provider>
    );
};
